import * as React from 'react';
import { PlanModel } from '@journeyapps-platform/lib-journey-core';
import { styled } from '../../../../../theme';
import { observer } from 'mobx-react';
import { MeteredWidget } from './MeteredWidget';
import { LoaderSpinner } from '../../../../../widgets/LoaderWidget';
import * as _ from 'lodash';

export interface PlanOverviewWidgetProps {
  plan: PlanModel;
  className?: any;
}

export const PlanOverviewWidget: React.FC<PlanOverviewWidgetProps> = observer((props) => {
  if (!props.plan.usage) {
    return (
      <S.CenterLoader>
        <LoaderSpinner />
      </S.CenterLoader>
    );
  }

  return (
    <S.Metered>
      {_.sortBy(props.plan.usage.metered, (i) => i.label).map((m) => {
        return (
          <S.MeteredEntry
            billing_enabled={props.plan.model.billing_enabled!}
            item={m}
            key={`${m.category}-${m.label}`}
          />
        );
      })}
    </S.Metered>
  );
});
namespace S {
  export const CenterLoader = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 200px;
  `;

  export const Container = styled.div`
    background: ${(p) => p.theme.header.background};
    padding: 30px;
    border-radius: 10px;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  `;

  export const Label = styled.div`
    color: ${(p) => p.theme.text.primary};
    font-size: 25px;
  `;

  export const MeteredEntry = styled(MeteredWidget)`
    margin-bottom: 10px;

    &:last-of-type {
      margin-bottom: 0;
    }
  `;

  export const Metered = styled.div``;
}
